import script from "./withdrawPasswordPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./withdrawPasswordPopup.vue?vue&type=script&setup=true&lang=ts"

import "./withdrawPasswordPopup.vue?vue&type=style&index=0&id=1138251b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1138251b"]])

export default __exports__